<!-- 商品推荐列表 -->
<template>
    <div class="main-container">
        <div class="filter-container">
            <SelectBrand :ifBody="0" @brandChange="onBrandChange"/>
            <el-select class="filter-item" v-model="filters.cat_id" filterable placeholder="品类" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option label="蛋糕" :value="BrandCat['蛋糕']"></el-option>
                <el-option label="零食" :value="BrandCat['零食']"></el-option>
                <el-option label="鲜花" :value="BrandCat['鲜花']"></el-option>
            </el-select>
            <el-input class="filter-item" v-model="filters.product_id" placeholder="商品ID" style="width:170px" clearable></el-input>
            <el-select class="filter-item" v-model="filters.status" placeholder="商品状态" style="width:170px" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option label="下架" value="1"></el-option>
                <el-option label="上架" value="0"></el-option>
            </el-select>
            <el-button class="filter-btn" type="primary" @click="search()">搜索</el-button>
            <el-button class="filter-btn" type="primary" @click="router.push('/marketing/similar-recommend-edit')">添加</el-button>
            <el-button class="filter-btn" type="primary" @click="dialogVisible=true">批量添加</el-button>
        </div>

        <el-table :data="tableData" border row-key="id" lazy :load="onLoadChildren">
            <el-table-column type="index" :index="tableIndex"></el-table-column>
            <el-table-column prop="brand_name" label="品牌"></el-table-column>
            <el-table-column prop="cat_name" label="品类"></el-table-column>
            <el-table-column prop="product_id" label="商品ID"></el-table-column>
            <el-table-column prop="title" label="商品名称"></el-table-column>
            <el-table-column prop="price" label="售价"></el-table-column>
            <el-table-column prop="status_name" label="状态"></el-table-column>
            <el-table-column prop="add_time" label="创建时间" width="160"></el-table-column>
            <el-table-column prop="up_time" label="修改时间" width="160"></el-table-column>
            <el-table-column label="操作" width="150">
                <template #default="scope">
                    <div class="action-list">
                        <!-- 当前行存在 relevance_id 字段时为推荐商品,否则为主商品.用来区分不同的操作 -->
                        <template v-if="scope.row.relevance_id">
                            <el-button type="danger" size="small" @click="onDel(scope.row, scope.$index)">删除</el-button>
                        </template>
                        <template v-else>
                            <el-button type="primary" size="small" @click="router.push('/marketing/similar-recommend-edit?id='+scope.row.product_id)">编辑</el-button>
                            <el-button type="primary" size="small" @click="onChangeStatus(scope.row)">{{ scope.row.status == 0 ? '下架' : '上架' }}</el-button>
                        </template>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Pagination :currentPage="filters.page" :total="total" @pageChange="onPageChange" @sizeChange="onSizeChange" />
        <!-- <el-pagination
            @current-change="onPageChange"
            :currentPage="filters.page"
            :page-size="filters.page_size"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination> -->

        <!-- 上传弹框 -->
        <el-dialog title="推荐商品批量添加" v-model="dialogVisible" :before-close="dialogBeforeClose">
            <el-form v-show="!dialogTableData.length" label-width="80px">
                <el-form-item>
                    <el-upload
                        class="upload-demo"
                        ref="upload"
                        action="/api/product/relevance_product_add_all"
                        :on-success="onUploadSuccess"
                        accept=".xls,.xlsx"
                    >
                        <el-button type="primary" size="small">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-link :href="`${Keys.baseUrl}/cake_api/template_title?title=推荐商品上传模板`" type="primary">下载批量添加模版</el-link>
                </el-form-item>
            </el-form>

            <!-- 批量添加数据回显 -->
            <el-table v-show="dialogTableData.length" :data="dialogTableData" border :row-class-name="rowClassName">
                <el-table-column prop="relevance_id" label="商品ID" ></el-table-column>
                <el-table-column prop="product_id" label="推荐商品ID" ></el-table-column>
                <el-table-column label="操作">
                    <template #default="scope">
                        <div class="action-list">
                            <el-button type="primary" size="small" @click="onTmpDel(scope.$index)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div v-show="dialogTableData.length" style="color:red;margin-top:15px">*注：红色字体为导入异常数据</div>

            <template #footer>
                <el-button @click="dialogBeforeClose">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import { useRouter } from 'vue-router'
import { defineComponent, getCurrentInstance, toRefs, reactive, onActivated } from 'vue'
import { useStore } from '@/store/index'
import Keys from '@/constant/key'
import { joinParams } from '@/utils/index'
import { BrandCat } from '@/enums/brand'
import SelectBrand from '@/components/SelectBrand.vue'
export default defineComponent({
name: 'ProductRecommend',
components: {SelectBrand,Pagination},
setup() {
    const { proxy } = getCurrentInstance()
    const router = useRouter()
    const store = useStore()

    const state = reactive({
        user_id: store.state.user.userInfo.id,
        filters: {
            brand_id:       '',     // 品牌ID
            cat_id:         null,   // 品类ID
            product_id:     null,   // 商品ID
            status:         null,   // 状态
            page:           1,      // 当前页码
            page_size:      10,     // 每页显示条数
        },
        tableData:          [],     // 表单数据
        total:              0,      // 总条数
        brandList:          [],     // 品牌列表,用于搜索

        dialogVisible:      false,  // 商品批量添加弹框
        dialogTableData:    [],     // 上传成功回显数据
        // 商品批量添加前回调
        onProductBeforeUpload () {
            if (state.brandId) {
                return true
            } else {
                proxy.$message({
                    type: 'error',
                    message: '用户信息中缺少品牌ID'
                })
                return false
            }
        },
        // 商品批量添加成功回调
        onProductUploadSuccess (res) {
            const {code, data:resData} = res
            if (code === 0) {
                state.uploadProductList = resData
            }
        },
        // 确认添加
        onProductUploadSure () {
            const {brandId:brand_id} = data
            if (!brand_id) {
                return proxy.$message({
                    type: 'error',
                    message: '用户信息中缺少品牌ID'
                })
            }

            proxy.$http.post('/admin/shop_product/add_shop_goods', {brand_id}).then(res => {
                const {code} = res
                if (code === 200) {
                    proxy.$message({
                        type: 'success',
                        message: '添加成功'
                    })
                    setTimeout(() => {
                        getList()
                        state.onProductUploadCancel()
                    })
                }
            })
        },
        // 取消添加
        onProductUploadCancel () {
            state.productDialogShow = false
            state.uploadProductList = []
            proxy.$refs.batchProductForm.clearFiles()
        },
        // 表格 index 连续
        tableIndex: (index) => {
            const { page, page_size } = state.filters
            return (page - 1) * page_size + index + 1
        },
        onBrandChange (val) {
            state.filters.brand_id = val
        },
        // 搜索
        search() {
            state.filters.page = 1
            getList()
        },
        onPageChange(val) {
            state.filters.page = val
            getList()
        },
        onSizeChange(val) {
            state.filters.page_size = val
            getList()
    }
    })    

    // 获取列表数据
    const getList = () => {
        proxy.$http.get(`/product/relevance_product_list?${joinParams(state.filters)}`).then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            let tmpList = data.data || []
            tmpList.map(item => item.hasChildren = true)
            state.tableData = tmpList
            state.total = data.total || 0
        })
    }
    // 获取品牌列表
    const getBrandList = () => {
        proxy.$http.get(`/dsapi/trade/brands_list`).then(res => {
            const { code, data, msg, total } = res
            if (code != 200) return proxy.$message({ type: 'error', message: msg })
            state.brandList = data
        })
    }
    // 加载推荐商品
    const onLoadChildren = (row, treeNode, resolve) => {
        const { tableData } = state
        proxy.$http.get(`/product/relevance_product_info_list?relevance_id=${row.product_id}`).then(res => {
            const {code, data, msg} = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            const index = tableData.findIndex(item => item.product_id === row.product_id)
            tableData[index].children = data
            resolve(data)
        })
    }
    // 主商品上下架
    const onChangeStatus = (row) => {
        const { product_id, title, status } = row
        proxy.$confirm(`确定要 ${status ? '上架' : '下架'} ${title} 吗?`, '提示', {
            type: 'warning'
        }).then(() => {
            proxy.$http.post('/product/relevance_product_status', {relevance_id: product_id}).then(res => {
                const {code, data, msg} = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                proxy.$message({ type: 'success', message: '操作成功' })
                getList()
            })
        }).catch(() => {
            console.log('取消上下架')
        })
    }
    // 推荐商品删除
    const onDel = (row) => {
        const { id, title, relevance_id } = row
        const { tableData } = state
        proxy.$confirm(`确定要删除【${title}】吗?`, '提示', {
            type: 'warning'
        }).then(() => {
            proxy.$http.post('/product/relevance_product_del', {del_id: id}).then(res => {
                const {code, msg} = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                proxy.$message({ type: 'success', message: '删除成功' })
                // 当前操作主商品的 index
                const parentIndex = tableData.findIndex(item => item.product_id === relevance_id)
                // 当前操作推荐商品的 index
                const index = tableData[parentIndex].children.findIndex(item => item.id === id)
                // 删除当前推荐商品
                tableData[parentIndex].children.splice(index, 1)
            })
        }).catch(() => {
            console.log('取消删除')
        })
    }
    // 批量添加成功
    const onUploadSuccess = (res) => {
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        state.dialogTableData = data
    }
    // 批量添加弹框关闭前清空数据
    const dialogBeforeClose = () => {
        proxy.$refs.upload.clearFiles()
        state.dialogTableData = []
        state.dialogVisible = false
    }
    // 将回显数据中错误行标红
    const rowClassName = ({row}) => {
        return row.str ? 'error-row' : ''
    }
    // 提交回显数据
    const onSubmit = () => {
        let { dialogTableData } = state
        let errorIndex = dialogTableData.findIndex(item => item.str==1)
        if (dialogTableData.length === 0) {
            return proxy.$message({ type: 'error', message: '至少上传一条推荐商品' })
        }
        if (errorIndex > -1) {
            return proxy.$message({ type: 'error', message: '存在异常数据，处理完成后再进行提交' })
        }
        proxy.$http.post('/product/relevance_product_all', {data: dialogTableData}).then(res => {
            const {code, data, msg} = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            proxy.$message({ type: 'success', message: '保存成功' })
            getList()
            dialogBeforeClose()
        })
    }
    // 回显数据删除
    const onTmpDel = (index) => {
        state.dialogTableData.splice(index, 1)
    }

    getBrandList()
    getList()

    getList()
    onActivated(() => {
        getList()
    })
    return { ...toRefs(state),  Keys, store, router, BrandCat, onLoadChildren, onChangeStatus, onDel, onUploadSuccess, dialogBeforeClose, rowClassName, onSubmit, onTmpDel }
}
})
</script>

<style lang="stylus" scoped>
    :deep(.el-table__row--level-1)
        background #FAFAFA
    :deep(.el-table .error-row)
        color #f55255
</style>